"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.receiveFileDelete = receiveFileDelete;
exports.attemptFilesFetch = attemptFilesFetch;
exports.receiveFilesFetch = receiveFilesFetch;
exports.failFilesFetch = failFilesFetch;
exports.removeFile = removeFile;
exports.renameFile = renameFile;
exports.moveFile = moveFile;
exports.uploadFile = uploadFile;
exports.getEditedImageUploadSucceeded = getEditedImageUploadSucceeded;
exports.getEditedImageUploadFailed = getEditedImageUploadFailed;
exports.uploadEditedImage = uploadEditedImage;
exports.uploadResizedImage = uploadResizedImage;
exports.replaceFile = replaceFile;
exports.saveEdit = saveEdit;
exports.setVidyardSyncState = setVidyardSyncState;
exports.softDeleteHubLVideoPlayer = softDeleteHubLVideoPlayer;
exports.getSelectImageToEditAction = getSelectImageToEditAction;
exports.getDeselectImageToEditAction = getDeselectImageToEditAction;
exports.getFetchSignedURLFailedAction = getFetchSignedURLFailedAction;
exports.downloadFromExternalUrl = exports.uploadFiles = exports.getBulkUploadAttemptedAction = exports.showUploadDisabledNotification = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _Raven = _interopRequireDefault(require("Raven"));

var _FloatingAlertStore = _interopRequireDefault(require("UIComponents/alert/FloatingAlertStore"));

var _imagePlaceholder = _interopRequireDefault(require("bender-url!FileManagerImages/images/image-placeholder.png"));

var FilesApi = _interopRequireWildcard(require("../api/Files"));

var VideoPlayersApi = _interopRequireWildcard(require("../api/VideoPlayers"));

var _Constants = require("../Constants");

var _dimensions = require("../utils/dimensions");

var _tempFileId = _interopRequireDefault(require("../utils/tempFileId"));

var _file = require("../utils/file");

var _ActionTypes = require("./ActionTypes");

var _Limits = require("./Limits");

var _hubLVideo = require("../utils/hubLVideo");

var _notifications = require("../utils/notifications");

var _logging = require("../utils/logging");

var _Permissions = require("../selectors/Permissions");

var _fileAccessibility = require("../utils/fileAccessibility");

function receiveFileDelete(fileId) {
  return {
    type: _ActionTypes.DELETE_FILE_SUCCEEDED,
    fileId: fileId
  };
}

function attemptFilesFetch(query) {
  return {
    type: _ActionTypes.FETCH_FILES_ATTEMPTED,
    status: _Constants.RequestStatus.PENDING,
    query: query
  };
}

function receiveFilesFetch(query, data) {
  return {
    type: _ActionTypes.FETCH_FILES_SUCCEEDED,
    status: _Constants.RequestStatus.SUCCEEDED,
    query: query,
    data: data
  };
}

function failFilesFetch(query, error) {
  return {
    type: _ActionTypes.FETCH_FILES_FAILED,
    status: error.status === 404 ? _Constants.RequestStatus.NOTFOUND : _Constants.RequestStatus.FAILED,
    query: query,
    error: error
  };
}

function removeFile(file) {
  return function (dispatch, getState, httpClient) {
    FilesApi.remove(file.get('id'), httpClient).then(function () {
      if ((0, _hubLVideo.isHubLVideo)(file.toJS())) {
        dispatch((0, _Limits.getDecreaseVideoQuantityUsedAction)(1));
      }

      dispatch(receiveFileDelete(file.get('id')));
    }, function (error) {
      dispatch({
        type: _ActionTypes.DELETE_FILE_FAILED,
        meta: {
          notification: {
            type: 'danger',
            titleText: _I18n.default.text('FileManagerCore.notifications.deleteFile.error.title'),
            message: _I18n.default.text('FileManagerCore.notifications.deleteFile.error.message', {
              filename: file.get('name')
            })
          }
        },
        error: error,
        file: file
      });
    }).done();
  };
}

function renameFileFailed(error, file) {
  var errorType = error && error.responseJSON ? error.responseJSON.errorType : '';

  var message = _I18n.default.text('FileManagerCore.notifications.renameFile.error.message', {
    filename: file.get('name')
  });

  if (errorType === 'FILE_MOVE_CONFLICT') {
    message = _I18n.default.text('FileManagerCore.notifications.renameFile.error.FILE_MOVE_CONFLICT');
  }

  return {
    type: _ActionTypes.RENAME_FILE_FAILED,
    data: file,
    meta: {
      notification: {
        type: 'danger',
        titleText: _I18n.default.text('FileManagerCore.notifications.renameFile.error.title'),
        message: message
      }
    },
    error: error
  };
}

function renameFile(file, newName) {
  return function (dispatch, getState, httpClient) {
    var newFile = file.set('name', newName);
    dispatch({
      type: _ActionTypes.RENAME_FILE_ATTEMPTED,
      data: newFile
    });
    return FilesApi.move(file.get('id'), {
      name: newName
    }, httpClient).then(function (data) {
      dispatch({
        type: _ActionTypes.RENAME_FILE_SUCCEEDED,
        data: data
      });
      return data;
    }, function (error) {
      (0, _logging.reportError)(error, {
        type: _ActionTypes.RENAME_FILE_FAILED
      });
      dispatch(renameFileFailed(error, file));
      throw error;
    });
  };
}

function moveFile(file, destination) {
  return function (dispatch, getState, httpClient) {
    dispatch({
      type: _ActionTypes.MOVE_FILE_ATTEMPTED
    });
    FilesApi.move(file.get('id'), {
      folder_id: destination
    }, httpClient).then(function (data) {
      dispatch({
        type: _ActionTypes.MOVE_FILE_SUCCEEDED,
        data: data
      });
    }, function (error) {
      var errorType = error && error.responseJSON ? error.responseJSON.errorType : '';

      var titleText = _I18n.default.text('FileManagerCore.notifications.moveFile.error.title'); // default message


      var message = _I18n.default.text('FileManagerCore.notifications.moveFile.error.message', {
        filename: file.get('name')
      });

      if (errorType === 'FILE_MOVE_CONFLICT') {
        message = _I18n.default.text('FileManagerCore.notifications.moveFile.error.FILE_MOVE_CONFLICT');
      }

      dispatch({
        type: _ActionTypes.MOVE_FILE_FAILED,
        meta: {
          notification: {
            type: 'danger',
            titleText: titleText,
            message: message
          }
        },
        error: error
      });
    }).done();
  };
}

function getUploadError(response) {
  var errorData = null;

  if (response.data) {
    if (typeof response.data === 'string') {
      try {
        errorData = JSON.parse(response.data);
      } catch (e) {} // eslint-disable-line no-empty

    } else if (typeof response.data === 'object') {
      errorData = response.data;
    }
  }

  return errorData;
}

var showUploadDisabledNotification = function showUploadDisabledNotification(readOnlyReason) {
  var copyInfo = (0, _notifications.getReadOnlyPermissionCopy)(readOnlyReason);

  _FloatingAlertStore.default.addAlert({
    'data-test-id': 'upload-attempted-while-disabled-alert',
    type: 'danger',
    titleText: copyInfo.explanation
  });
};

exports.showUploadDisabledNotification = showUploadDisabledNotification;

var handleUploadInReadOnly = function handleUploadInReadOnly(readOnlyReason) {
  showUploadDisabledNotification(readOnlyReason);
  var err = new Error("Attempted upload while readOnly, reason: " + readOnlyReason);
  err.readOnlyReason = readOnlyReason;
  return Promise.reject(err);
};

var getUploadOptionsWithThumbnailGenerationMethod = function getUploadOptionsWithThumbnailGenerationMethod(options) {
  return Object.assign({
    forceSynchronousImageProcessing: true
  }, options);
};

function uploadFile(file) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch, getState, httpClient) {
    var readOnlyReason = (0, _Permissions.getReadOnlyReason)(getState());

    if (readOnlyReason) {
      return handleUploadInReadOnly(readOnlyReason);
    }

    var tempId = options.tempId || (0, _tempFileId.default)();

    var progress = function progress(event) {
      dispatch({
        type: _ActionTypes.UPLOAD_FILE_PROGRESS,
        progress: event.loaded / event.total * 95,
        tempId: tempId
      });
    };

    var _splitNameAndExtensio = (0, _file.splitNameAndExtension)(file),
        name = _splitNameAndExtensio.name,
        extension = _splitNameAndExtensio.extension;

    var type = (0, _file.getType)(extension);
    var isImage = type === _Constants.FileTypes.IMG;

    _Raven.default.captureBreadcrumb({
      type: 'message',
      message: _ActionTypes.UPLOAD_FILE_ATTEMPTED,
      data: Object.assign({}, options, {
        tempId: tempId,
        name: name,
        extension: extension,
        type: type,
        size: file.size
      })
    });

    var tempUrl = '';

    if ((0, _file.canPreviewLocalFile)(file)) {
      tempUrl = window.URL.createObjectURL(file);
    } else if (isImage) {
      tempUrl = _imagePlaceholder.default;
    }

    var upload = function upload() {
      var dimensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      dispatch({
        type: _ActionTypes.UPLOAD_FILE_ATTEMPTED,
        tempFile: file,
        folderId: options.folderId,
        dimensions: dimensions,
        tempUrl: tempUrl,
        tempId: tempId
      });
      var uploadPromise;

      if (options.access) {
        uploadPromise = FilesApi.uploadFileV3(file, options.access, options, {
          httpClient: httpClient,
          updateProgress: progress
        });
      } else {
        uploadPromise = FilesApi.uploadFile(file, progress, getUploadOptionsWithThumbnailGenerationMethod(options), httpClient);
      }

      return uploadPromise.then(function (data) {
        var uploadedFile = data.getIn(['objects', 0]);
        dispatch({
          type: _ActionTypes.UPLOAD_FILE_SUCCEEDED,
          file: uploadedFile,
          tempId: tempId
        });

        if (tempUrl) {
          window.URL.revokeObjectURL(tempUrl);
        }

        _Raven.default.captureBreadcrumb({
          type: 'message',
          message: _ActionTypes.UPLOAD_FILE_SUCCEEDED,
          data: Object.assign({}, options, {
            tempId: tempId,
            file: uploadedFile.toJS()
          })
        });

        return uploadedFile;
      }, function (response) {
        var message = _I18n.default.text('FileManagerCore.notifications.upload.error.message', {
          filename: name
        });

        var errorData = getUploadError(response);

        if (errorData && errorData.errorType === 'VIRUS_FOUND') {
          message = _I18n.default.text('FileManagerCore.notifications.upload.error.virusFoundMessage', {
            filename: name
          });
        }

        dispatch({
          type: _ActionTypes.UPLOAD_FILE_FAILED,
          meta: {
            notification: {
              type: 'danger',
              titleText: _I18n.default.text('FileManagerCore.notifications.upload.error.title'),
              message: message
            }
          },
          error: response,
          tempId: tempId
        });

        if (tempUrl) {
          window.URL.revokeObjectURL(tempUrl);
        }

        (0, _logging.reportError)(response, {
          action: _ActionTypes.UPLOAD_FILE_FAILED,
          fileType: type,
          fileExtension: extension,
          fileSize: file.size,
          usingFileUploadV3: Boolean(options.access)
        });
      });
    };

    if (isImage && tempUrl) {
      return (0, _dimensions.getAsyncDimensions)(tempUrl).then(upload);
    }

    return upload();
  };
}

function getEditedImageUploadSucceeded(file, titleText) {
  return {
    type: _ActionTypes.UPLOAD_EDITED_IMAGE_SUCCEEDED,
    file: file,
    tempId: null,
    meta: {
      notification: {
        type: 'success',
        titleText: titleText
      }
    }
  };
}

function getEditedImageUploadFailed() {
  return {
    type: _ActionTypes.UPLOAD_EDITED_IMAGE_FAILED,
    meta: {
      notification: {
        type: 'danger',
        titleText: _I18n.default.text('FileManagerCore.notifications.uploadEditedFile.error.title'),
        message: _I18n.default.text('FileManagerCore.notifications.uploadEditedFile.error.message')
      }
    }
  };
}

function getTextForUploadEditedImgSuccess(file) {
  return _I18n.default.text('FileManagerCore.notifications.uploadEditedFile.success.title', {
    fileName: file.get('name')
  });
}

function uploadEditedImage(file, fileName, folderId, uploadedFileAccess, onSaveComplete) {
  return function (dispatch, getState, httpClient) {
    dispatch({
      type: _ActionTypes.UPLOAD_EDITED_IMAGE_ATTEMPTED
    });
    return FilesApi.uploadFileV3(file, uploadedFileAccess, {
      fileName: fileName,
      folderId: folderId
    }, {
      httpClient: httpClient
    }).then(function (data) {
      var savedFile = data.getIn(['objects', 0]);
      dispatch(getEditedImageUploadSucceeded(savedFile, getTextForUploadEditedImgSuccess(savedFile)));

      if (onSaveComplete) {
        onSaveComplete(savedFile.get('url'), savedFile);
      }
    }, function () {
      dispatch(getEditedImageUploadFailed());
    }).done();
  };
}

function uploadResizedImage(fileId, newWidth, uploadedFileAccess, onSaveComplete) {
  return function (dispatch, getState, httpClient) {
    dispatch({
      type: _ActionTypes.UPLOAD_EDITED_IMAGE_ATTEMPTED
    });
    return FilesApi.uploadResizedImage(fileId, newWidth, httpClient).then(function (file) {
      dispatch(getEditedImageUploadSucceeded(file, getTextForUploadEditedImgSuccess(file)));

      if (onSaveComplete) {
        onSaveComplete(file.get('url'), file);
      }
    }, function () {
      dispatch(getEditedImageUploadFailed());
    }).done();
  };
}

var getBulkUploadAttemptedAction = function getBulkUploadAttemptedAction(uploadingFiles, path, folderId) {
  return {
    type: _ActionTypes.BULK_UPLOAD_FILES_ATTEMPTED,
    uploadingFiles: uploadingFiles,
    path: path,
    folderId: folderId
  };
};

exports.getBulkUploadAttemptedAction = getBulkUploadAttemptedAction;

var uploadFiles = function uploadFiles(fileList) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch, getState) {
    var files = Array.prototype.slice.call(fileList);
    var readOnlyReason = (0, _Permissions.getReadOnlyReason)(getState());

    if (readOnlyReason) {
      return handleUploadInReadOnly(readOnlyReason);
    }

    dispatch(getBulkUploadAttemptedAction(files, options.path, options.folderId));
    return Promise.all(files.map(function (file) {
      return dispatch(uploadFile(file, options));
    }));
  };
};

exports.uploadFiles = uploadFiles;

function replaceFile(existingFile, localFile) {
  return function (dispatch) {
    var fileId = existingFile.get('id');

    var progress = function progress(event) {
      dispatch({
        type: _ActionTypes.REPLACE_FILE_PROGRESS,
        progress: event.loaded / event.total * 95,
        fileId: fileId
      });
    };

    var _splitNameAndExtensio2 = (0, _file.splitNameAndExtension)(localFile),
        extension = _splitNameAndExtensio2.extension;

    var type = (0, _file.getType)(extension);
    var isImage = type === _Constants.FileTypes.IMG;
    var tempUrl = '';

    if ((0, _file.canPreviewLocalFile)(localFile)) {
      tempUrl = window.URL.createObjectURL(localFile);
    }

    var upload = function upload() {
      var dimensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      dispatch({
        type: _ActionTypes.REPLACE_FILE_ATTEMPTED,
        tempFile: localFile,
        dimensions: dimensions,
        tempUrl: tempUrl,
        fileId: fileId
      });
      return FilesApi.replaceFile(fileId, localFile, (0, _fileAccessibility.getFileAccess)(existingFile), {
        updateProgress: progress
      }).then(function (response) {
        var updatedFile = response.getIn(['objects', 0]);
        updatedFile = updatedFile.merge({
          replaced: true
        });
        dispatch({
          type: _ActionTypes.REPLACE_FILE_SUCCEEDED,
          file: updatedFile
        });

        if (tempUrl) {
          window.URL.revokeObjectURL(tempUrl);
        }
      }, function (response) {
        var message = _I18n.default.text('FileManagerCore.notifications.replace.error.message', {
          filename: existingFile.get('name')
        });

        var errorData = getUploadError(response);

        if (errorData && errorData.errorType === 'VIRUS_FOUND') {
          message = _I18n.default.text('FileManagerCore.notifications.replace.error.virusFoundMessage', {
            filename: name
          });
        }

        dispatch({
          type: _ActionTypes.REPLACE_FILE_FAILED,
          meta: {
            notification: {
              type: 'danger',
              titleText: _I18n.default.text('FileManagerCore.notifications.replace.error.title'),
              message: message
            }
          },
          file: existingFile,
          error: response
        });

        if (tempUrl) {
          window.URL.revokeObjectURL(tempUrl);
        }
      }).done();
    };

    if (isImage && tempUrl) {
      (0, _dimensions.getAsyncDimensions)(tempUrl).then(upload);
    } else {
      upload();
    }
  };
}

function saveEdit(originalId, file, url, uploadedFileAccess) {
  return function (dispatch, getState, httpClient) {
    var tempId = (0, _tempFileId.default)();
    dispatch({
      type: _ActionTypes.SAVE_EDIT_ATTEMPTED,
      tempUrl: url,
      fileId: originalId,
      originalId: originalId,
      file: file,
      tempId: tempId
    });
    return FilesApi.downloadFromUrl(file, url, uploadedFileAccess, httpClient).then(function (response) {
      dispatch({
        type: _ActionTypes.SAVE_EDIT_SUCCEEDED,
        file: response,
        originalId: originalId,
        tempId: tempId
      });
      return response;
    });
  };
}

var downloadFromExternalUrl = function downloadFromExternalUrl(url, uploadedFileAccess) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      name = _ref.name;

  return function (dispatch) {
    dispatch({
      type: _ActionTypes.DOWNLOAD_FROM_EXTERNAL_URL_ATTEMPTED
    });
    var fileDownloadOptions = {
      name: name,
      folderPath: _Constants.IMPORTED_IMAGE_FOLDER_PATH
    };
    return FilesApi.downloadFromUrl(fileDownloadOptions, url, uploadedFileAccess).then(function (file) {
      dispatch({
        type: _ActionTypes.DOWNLOAD_FROM_EXTERNAL_URL_SUCCEEDED,
        file: file
      });
      return file;
    }).catch(function (err) {
      (0, _logging.reportError)(err, {
        type: 'DOWNLOAD_FROM_EXTERNAL_URL'
      });
      throw err;
    });
  };
};

exports.downloadFromExternalUrl = downloadFromExternalUrl;

function getCreateVidyardPlayerSucceededAction(file) {
  return {
    type: _ActionTypes.CREATE_VIDYARD_PLAYERID_SUCCEEDED,
    file: file
  };
}

function getCreateVidyardPlayerAttemptedAction() {
  return {
    type: _ActionTypes.CREATE_VIDYARD_PLAYERID_ATTEMPTED
  };
}

function getCreateVidyardPlayerFailedAction() {
  return {
    type: _ActionTypes.CREATE_VIDYARD_PLAYERID_FAILED,
    meta: {
      notification: {
        type: 'danger',
        titleText: _I18n.default.text('FileManagerCore.notifications.syncToVidyard.error.title'),
        message: _I18n.default.text('FileManagerCore.notifications.syncToVidyard.error.message')
      }
    }
  };
}

function setVidyardSyncState(file) {
  return function (dispatch, getState, httpClient) {
    dispatch(getCreateVidyardPlayerAttemptedAction());
    VideoPlayersApi.createPlayerForVideo(file.get('id'), httpClient).then(function (newHostingInfo) {
      dispatch(getCreateVidyardPlayerSucceededAction((0, _file.getUpdatedPlayerIdVideoFile)(file, newHostingInfo)));
    }, function () {
      return dispatch(getCreateVidyardPlayerFailedAction());
    }).done();
  };
}

function getDeleteVidyardPlayerFailedAction() {
  return {
    type: _ActionTypes.SOFT_DELETE_VIDYARD_PLAYERID_FAILED,
    meta: {
      notification: {
        type: 'danger',
        titleText: _I18n.default.text('FileManagerCore.notifications.unsyncFromVidyard.error.title'),
        message: _I18n.default.text('FileManagerCore.notifications.unsyncFromVidyard.error.message')
      }
    }
  };
}

function getDeleteVidyardPlayerSucceededAction(file) {
  return {
    type: _ActionTypes.SOFT_DELETE_VIDYARD_PLAYERID_SUCCEEDED,
    file: file
  };
}

function softDeleteHubLVideoPlayer(playerId, file) {
  return function (dispatch, getState, httpClient) {
    VideoPlayersApi.softDeleteHubLVideoPlayer(playerId, httpClient).then(function () {
      return dispatch(getDeleteVidyardPlayerSucceededAction((0, _file.softDeleteVidyardPlayerIdFromFile)(file, playerId)));
    }, function () {
      return dispatch(getDeleteVidyardPlayerFailedAction());
    }).done();
  };
}

function getSelectImageToEditAction(file, selectedImgFrom) {
  return {
    type: _ActionTypes.IMAGE_TO_EDIT_SELECTED,
    file: file,
    selectedImgFrom: selectedImgFrom
  };
}

function getDeselectImageToEditAction() {
  return {
    type: _ActionTypes.IMAGE_TO_EDIT_DESELECTED
  };
}

function getFetchSignedURLFailedAction() {
  return {
    type: _ActionTypes.FETCH_SIGNED_URL_FAILED,
    meta: {
      notification: (0, _notifications.getFetchSignedURLFailedNotification)()
    }
  };
}